module.exports = __webpack_public_path__ + "static/img/022白桦节2稿.bdca592.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/smPicImgs/022白桦节2稿.jpg
// module id = LBPM
// module chunks = 0